import { FieldErrors, UseFormRegister } from "react-hook-form";
import horizontal from "../../images/horizontal 550 no background.png";
import inverted from "../../images/inverted 550 no background.png";
import rolled from "../../images/rolled 550 no background.png";
import vertical from "../../images/vertical 550 no background.png";
import { FormTypes } from "../../types/FormTypes";

interface IInputsOrientation {
  register: UseFormRegister<FormTypes>;
  errors: FieldErrors<FormTypes>;
  onBlurHandler: (event: any) => void;
}

function InputsOrientation(props: IInputsOrientation) {
  const { errors, register, onBlurHandler } = props;

  return (
    <div className="d-flex">
      <div>
        <label>
          <div className="radio-image border">
            <input
              type="radio"
              {...register("orientation", {
                required: true,
                onBlur: onBlurHandler,
              })}
              value="orientationHorizontal"
            />
            <img
              src={horizontal}
              alt="horizontal"
              style={{ objectFit: "contain" }}
            />
          </div>
          <p className="styled-font">Horizontal</p>
        </label>
      </div>
      <div>
        <label>
          <div className="radio-image border">
            <input
              type="radio"
              {...register("orientation", {
                required: true,
                onBlur: onBlurHandler,
              })}
              value="orientationRolled"
            />
            <img
              src={rolled}
              alt="rolled"
              style={{ objectFit: "contain" }}
            />
          </div>
          <p className="styled-font">Rolled</p>
        </label>
      </div>
      <div>
        <label>
          <div className="radio-image border">
            <input
              type="radio"
              {...register("orientation", {
                required: true,
                onBlur: onBlurHandler,
              })}
              value="orientationInverted"
            />
            <img
              src={inverted}
              alt="inverted"
              style={{ objectFit: "contain" }}
            />
          </div>
          <p className="styled-font">Inverted</p>
        </label>
      </div>
      <div>
        <label>
          <div className="radio-image border">
            <input
              type="radio"
              {...register("orientation", {
                required: true,
                onBlur: onBlurHandler,
              })}
              value="orientationVertical"
            />
            <img
              src={vertical}
              alt="vertical"
              style={{ objectFit: "contain" }}
            />
          </div>
          <p className="styled-font">Vertical</p>
        </label>
      </div>
    </div>
  );
}

export default InputsOrientation;
